"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class MenuApi {
    constructor(api) {
        this.api = api;
    }
    getCategoryMenus(merchantId, categoryId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/menu';
            const response = yield this.api.axiosGo.get(endpoint, {
                params: {
                    merchantID: merchantId,
                    categoryID: categoryId,
                    takeaway: null,
                },
            });
            return response.data;
        });
    }
    getCategorySets(merchantId, categoryId, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/set';
            const response = yield this.api.axiosGo.get(endpoint, {
                params: Object.assign({ merchantID: merchantId, categoryID: categoryId, takeaway: null }, query),
            });
            return response.data;
        });
    }
    getSetMenus(merchantId, setId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/setmenu';
            const response = yield this.api.axiosGo.get(endpoint, {
                params: {
                    merchantID: merchantId,
                    setID: setId,
                    takeaway: null,
                },
            });
            return response.data;
        });
    }
    getPromotedSetMenus() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.get('/m/setmenu', {
                params: { promoted: true },
            });
            return response.data;
        });
    }
    // * set
    getSet(id, locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.get(`/m/set/info/${id}`, {
                headers: {
                    'Accept-Language': locale != null ? locale : this.api.locale,
                },
            });
            return response.data;
        });
    }
    getSoldOutSets() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.get('/m/set', {
                params: { soldOut: true },
            });
            return response.data;
        });
    }
    getPromotedSets() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.get('/m/set', {
                params: { promoted: true },
            });
            return response.data;
        });
    }
    createSet(set) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/set';
            const response = yield this.api.axiosGo.post(endpoint, set);
            return response.data;
        });
    }
    updateSet(setId, set) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/info`;
            const response = yield this.api.axiosGo.post(endpoint, set);
            return response.data;
        });
    }
    updateSetImage(setId, file) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append('file', file);
            /** @type {AxiosResponse} */
            const response = yield this.api.axiosNode.post(`/m/set/${setId}/image`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        });
    }
    deleteSetImage(setId) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {AxiosResponse} */
            const response = yield this.api.axiosGo.delete(`/m/set/${setId}/image`);
            return response.data;
        });
    }
    deleteSet(setId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}`;
            yield this.api.axiosGo.delete(endpoint);
        });
    }
    // 修改外帶價格
    updateSetTakeawayPrice(setId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/price`;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    addSetStep(setId, step) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/step`;
            const response = yield this.api.axiosGo.post(endpoint, step);
            return response.data;
        });
    }
    updateSetStep(setId, step) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/step/${step.key}`;
            const response = yield this.api.axiosGo.post(endpoint, step);
            return response.data;
        });
    }
    deleteSetStep(setId, stepKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/step/${stepKey}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
    updateSetStepOrder(setId, stepKeys) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/sortstep`;
            const response = yield this.api.axiosGo.post(endpoint, {
                keys: stepKeys,
            });
            return response.data;
        });
    }
    // 允許外賣
    updateSetTakeawayEnable(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/set/takeaway';
            const response = yield this.api.axiosGo.post(endpoint, { enabled });
            return response.data;
        });
    }
    // 允許堂食
    updateSetNonTakeawayEnable(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/set/nontakeaway';
            const response = yield this.api.axiosGo.post(endpoint, { enabled });
            return response.data;
        });
    }
    // * Set Menu
    addSetMenu(setId, step, menuId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/setmenu';
            const response = yield this.api.axiosGo.post(endpoint, {
                setID: setId,
                step: step,
                menuID: menuId,
            });
            return response.data;
        });
    }
    updateSetMenu(setId, setMenuId, setMenu) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/setmenu/${setMenuId}/info`;
            const response = yield this.api.axiosGo.post(endpoint, Object.assign(Object.assign({}, setMenu), { setID: setId, categoryID: setMenu.categoryId }));
            return response.data;
        });
    }
    updateSetMenuPrice(setMenuId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/setmenu/${setMenuId}/price`;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    deleteSetMenu(setMenuId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/setmenu/${setMenuId}`;
            yield this.api.axiosGo.delete(endpoint);
        });
    }
    // * Set Option
    // 新增選項群
    createSetOptionGroup(setId, optionGroup) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/group`;
            const response = yield this.api.axiosGo.post(endpoint, optionGroup);
            return response.data;
        });
    }
    // 修改選項群
    updateSetOptionGroup(setId, groupId, optionGroup) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/group/${groupId}`;
            const response = yield this.api.axiosGo.post(endpoint, optionGroup);
            return response.data;
        });
    }
    // 刪除選項群
    deleteSetOptionGroup(setId, groupId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/group/${groupId}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
    // 新增選項
    createSetOption(setId, groupId, option) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/group/${groupId}/opt`;
            const response = yield this.api.axiosGo.post(endpoint, option);
            return response.data;
        });
    }
    // 修改選項
    updateSetOption(setId, groupId, optionId, option) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/group/${groupId}/opt/${optionId}`;
            const response = yield this.api.axiosGo.post(endpoint, option);
            return response.data;
        });
    }
    // 刪除選項
    deleteSetOption(setId, groupId, optionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/set/${setId}/group/${groupId}/opt/${optionId}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
    // * Menu
    getMenu(id, setting = false, locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.get(`/m/menu/info/${id}`, {
                headers: {
                    'Accept-Language': locale != null ? locale : this.api.locale,
                },
                params: {
                    setting,
                },
            });
            return response.data;
        });
    }
    getSoldOutMenus() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.get('/m/menu', {
                params: { soldOut: true },
            });
            return response.data;
        });
    }
    getPromotedMenus() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.get('/m/menu', {
                params: { promoted: true },
            });
            return response.data;
        });
    }
    // 建立 menu，要另外再 call updateMenuTakeawayPrice, updateMenuTakeawayEnable 和 updateMenuNonTakeawayEnable
    createMenu(menu) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/menu';
            const response = yield this.api.axiosGo.post(endpoint, menu);
            return response.data;
        });
    }
    deleteMenu(menuId, perm = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}`;
            yield this.api.axiosGo.delete(endpoint, { params: { perm } });
        });
    }
    revealMenu(menuId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.api.axiosGo.put(`/m/menu/${menuId}/reveal`);
        });
    }
    updateMenu(menuId, menu) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/info`;
            const response = yield this.api.axiosGo.post(endpoint, menu);
            return response.data;
        });
    }
    updateMenuImage(menuId, file) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append('file', file);
            /** @type {AxiosResponse} */
            const response = yield this.api.axiosNode.post(`/m/menu/${menuId}/image`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        });
    }
    deleteMenuImage(menuId) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {AxiosResponse} */
            const response = yield this.api.axiosGo.delete(`/m/menu/${menuId}/image`);
            return response.data;
        });
    }
    // 修改外帶價格
    updateMenuTakeawayPrice(menuId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/price`;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    // 允許外賣
    updateMenuTakeawayEnable(menuId, enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/takeaway`;
            const response = yield this.api.axiosGo.post(endpoint, { enabled });
            return response.data;
        });
    }
    // 允許堂食
    updateMenuNonTakeawayEnable(menuId, enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/nontakeaway`;
            const response = yield this.api.axiosGo.post(endpoint, { enabled });
            return response.data;
        });
    }
    // * Menu Option
    // 新增選項群
    createMenuOptionGroup(menuId, optionGroup) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/group`;
            const response = yield this.api.axiosGo.post(endpoint, optionGroup);
            return response.data;
        });
    }
    // 修改選項群
    updateMenuOptionGroup(menuId, groupId, optionGroup) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/group/${groupId}`;
            const response = yield this.api.axiosGo.post(endpoint, optionGroup);
            return response.data;
        });
    }
    // 刪除選項群
    deleteMenuOptionGroup(menuId, groupId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/group/${groupId}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
    // 新增選項
    createMenuOption(menuId, groupId, option) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/group/${groupId}/opt`;
            const response = yield this.api.axiosGo.post(endpoint, option);
            return response.data;
        });
    }
    // 修改選項
    updateMenuOption(menuId, groupId, optionId, option) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/group/${groupId}/opt/${optionId}`;
            const response = yield this.api.axiosGo.post(endpoint, option);
            return response.data;
        });
    }
    // 刪除選項
    deleteMenuOption(menuId, groupId, optionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/menu/${menuId}/group/${groupId}/opt/${optionId}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
    // 更改預設選項群組
    updateMenuOptionGroupPresets(menuId, optionGroupPresets, locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post(`/m/menu/${menuId}/optiongrouppreset`, {
                optionGroupPresets,
                locale,
            });
            return response.data;
        });
    }
    // 售罄
    setMenuSold(menuId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.put(`/m/menu/${menuId}/sold`);
            return response.data;
        });
    }
    // 有貨
    setMenuStock(menuId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.put(`/m/menu/${menuId}/stock`);
            return response.data;
        });
    }
    // * Option Group Preset
    getOptionGroupPresets(locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.get('/m/optiongrouppreset', {
                headers: {
                    'Accept-Language': locale != null ? locale : this.api.locale,
                },
                params: {
                    locale: locale != null ? locale : this.api.locale,
                },
            });
            return response.data;
        });
    }
    createOptionGroupPreset(optionGroupPreset) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/optiongrouppreset', optionGroupPreset);
            return response.data;
        });
    }
    updateOptionGroupPreset(optionGroupPreset) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post(`/m/optiongrouppreset/${optionGroupPreset.id}`, optionGroupPreset);
            return response.data;
        });
    }
    deleteOptionGroupPreset(optionGroupPresetId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.api.axiosGo.delete(`/m/optiongrouppreset/${optionGroupPresetId}`);
        });
    }
}
exports.default = MenuApi;
//# sourceMappingURL=Menu.js.map